
import { Component, Vue } from 'vue-property-decorator'
import SearchNav from '@/views/industryMall/shop/template/SearchNav.vue'
import GoodsResultCard from '@/views/industryMall/shop/template/GoodsResultCard.vue'
import {
  addStoreSearchHistory,
  getCyStoreGoodsList,
  isGoodsValid,
  ShopGoodsInfoDto
} from '@/api/industryMall'
import { Getter } from 'vuex-class'

@Component({
  name: 'SearchGoods',
  components: { SearchNav, GoodsResultCard }
})
export default class SearchGoods extends Vue {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string
  searchList = []

  refreshing = false
  loading = false
  finished = false

  params = {
    storeId: '',
    keyword: '',
    companyId:'',
    pageSize: 20,
    pageIndex: 1
  }
  listScrollTop = 0

  created() {
    this.params.keyword = this.$route.query.keyword as string
    this.params.storeId = this.$route.query.storeId as string
    this.params.companyId = this.companyId
    this.getList()
  }

  handleScroll (event: any) {
    this.listScrollTop = event.target.scrollTop
  }

  activated() {
    document.querySelector('.arrival-list').scrollTo(0, this.listScrollTop)
  }

  // 产业商城搜索历史记录管理（SM）
  addStoreSearchHistory() {
    // console.log('this', this.keyword, this.partnerCompanyId)
    const data = {
      searchType: 3,
      keyword: this.params.keyword,
      storeId: this.params.storeId,
      companyId:this.companyId
    }
    console.log('data------2', data)
    addStoreSearchHistory({ ...data }).then((res) => {
      console.log('res', res)
    })
  }
  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }
  // 刷新
  onLoad() {
    this.params.pageIndex++
    this.loading = true
    this.getList()
  }

  searchFunc(keyword: string) {
    console.log('keyword', keyword)
    this.params.keyword = keyword
    this.params.pageIndex = 1
    // this.getList()
    this.searchList = []
    this.getList()
  }
  getList() {
    let param = {
      ...this.params
      // partnerCompanyId: this.partnerCompanyId,
    }
    this.addStoreSearchHistory()
    getCyStoreGoodsList(param)
      .then((res) => {
        if (this.refreshing) {
          this.searchList = []
        }
        this.searchList = this.searchList.concat(res.data.records || [])
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        }else {
          this.finished = false
        }
      })
      .finally(() => {
        this.refreshing = false
        this.loading = false
      })
  }
  /**
   * 跳转商品详情
   */
  async toDetail(item: ShopGoodsInfoDto) {
    const val = await this.isGoodsValid(item)
    console.log('val-----', val)
    if (val) {
      this.$router.push({
        path: '/goodsMallDetail',
        query: {
          goodsId: item.goodsId,
          storeId: item.storeId
        }
      })
    } else {
      this.$dialog
        .alert({
          message: '商品过期不存在'
        })
        .then(() => {
          // this.getList()
          this.onRefresh()
        })
    }
  }
  // 商品是否存在
  isGoodsValid(item: ShopGoodsInfoDto) {
    const params = {
      shopId: item.storeId,
      goodsId: item.goodsId
    }
    return isGoodsValid(params)
      .then((res) => {
        if (res.data.isValid) {
          return true
        } else {
          return false
        }
      })
      .catch(() => {
        console.log('失败了')
        return false
      })
  }
}
